(() => {
  'use strict';

  const roleOffsets = { pack: 0, food: 18, use: 32, after: 8 };

  function galleryStatus(root = document) {
    root.querySelectorAll('[data-av-pdp-v3] [data-au-hero-media]:not([data-avp4-gallery-ready])').forEach((gallery) => {
      gallery.dataset.avp4GalleryReady = 'true';
      const slides = [...gallery.querySelectorAll('[data-slide]')];
      if (!slides.length) return;

      let status = null;
      let lastMediaId = null;
      if (slides.length > 1) {
        status = document.createElement('div');
        status.className = 'avp4-gallery-status';
        status.setAttribute('aria-live', 'polite');
        status.innerHTML = `<span aria-hidden="true"></span><b>1 / ${slides.length}</b><small hidden></small>`;
        gallery.append(status);
      }

      const update = () => {
        const active = gallery.querySelector('.media--active,[aria-hidden="false"]') || slides[0];
        const index = Math.max(0, slides.indexOf(active));
        const role = active.dataset.avMediaRole || 'unclassified';
        const label = active.dataset.avMediaRoleLabel || '';
        const mediaId = active.dataset.mediaId || '';
        gallery.dataset.avActiveMediaRole = role;

        if (status) {
          status.querySelector('b').textContent = `${index + 1} / ${slides.length}`;
          const labelElement = status.querySelector('small');
          labelElement.textContent = label;
          labelElement.hidden = !label;
        }

        gallery.querySelectorAll('[data-av-media-role-trigger]').forEach((thumb) => {
          const button = thumb.querySelector('[data-thumb-link]');
          const selected = Boolean(mediaId && button?.dataset.mediaId === mediaId);
          thumb.classList.toggle('is-active', selected);
          button?.setAttribute('aria-current', String(selected));
        });

        if (lastMediaId !== null && mediaId && mediaId !== lastMediaId) {
          window.AVAnalytics?.legacy('australia:pdp_gallery_change', {
            product_id: gallery.dataset.productId || null,
            media_id: mediaId,
            media_position: index + 1,
            media_role: role,
            interaction_type: 'gallery_change'
          });
        }
        lastMediaId = mediaId;

        const trace = gallery.querySelector('.av-trace[data-au-visual-grammar]');
        const base = Math.min(92, Math.max(8, Number(gallery.dataset.avBaseTrackProgress) || 56));
        const progress = Math.min(92, base + (roleOffsets[role] ?? 0));
        window.auVisualGrammar?.syncTrack(trace, progress);
      };

      new MutationObserver(update).observe(gallery, {
        attributes: true,
        subtree: true,
        attributeFilter: ['class', 'aria-hidden', 'data-active-media']
      });
      update();
    });
  }

  function track(root = document) {
    root.querySelectorAll('[data-avp4-track]:not([data-avp4-track-ready])').forEach((element) => {
      element.dataset.avp4TrackReady = 'true';
      element.addEventListener('click', () => {
        const eventName = element.dataset.avp4Track || '';
        if (!eventName.startsWith('australia:')) return;
        window.AVAnalytics?.legacy(eventName, { product_id: element.dataset.productId || null });
      });
    });
  }


  function init(root = document) {
    galleryStatus(root);
    track(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
